export default function About() {
  return (
    <section id="about" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(0,217,255,0.03) 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#8b5cf6]/10 border border-[#8b5cf6]/30 px-4 py-2 rounded-full mb-6">
            <i className="ri-information-line text-[#8b5cf6]"></i>
            <span className="text-[#8b5cf6] text-sm font-medium">About Bellibutton</span>
          </div>
          <h2 className="text-5xl font-bold text-white mb-6 font-['Space_Grotesk']">
            Why Bellibutton?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            A unified approach to managing code quality standards across all your projects and languages
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/10 rounded-2xl p-8">
              <div className="w-14 h-14 bg-[#00d9ff]/10 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-lightbulb-flash-line text-[#00d9ff] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">The Problem</h3>
              <p className="text-gray-400 leading-relaxed">
                Managing different linter configurations across multiple projects and languages is tedious and error-prone. Each language has its own linting tool with different configuration formats, making it impossible to maintain consistency.
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-white/10 rounded-2xl p-8">
              <div className="w-14 h-14 bg-[#8b5cf6]/10 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-rocket-line text-[#8b5cf6] text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">The Solution</h3>
              <p className="text-gray-400 leading-relaxed">
                Bellibutton provides a single, unified rule set that can be exported to any language-specific linter. Define your code quality standards once, and apply them everywhere - from JavaScript to Python, Rust to Go.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-[#00d9ff] to-[#8b5cf6] rounded-3xl blur-3xl opacity-20"></div>
            <div className="relative bg-[#1a1a1a] border border-white/10 rounded-3xl p-8">
              <h3 className="text-2xl font-bold text-white mb-6">Key Benefits</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-[#00d9ff]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#00d9ff]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Single Source of Truth</h4>
                    <p className="text-gray-400 text-sm">Define your lint rules once and export to any language or framework</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-[#00d9ff]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#00d9ff]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Cross-Language Support</h4>
                    <p className="text-gray-400 text-sm">Works with ESLint, Pylint, RuboCop, Rustfmt, and many more</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-[#00d9ff]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#00d9ff]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Easy Comparison</h4>
                    <p className="text-gray-400 text-sm">Quickly identify and manage differences in lint values between projects</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-[#00d9ff]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#00d9ff]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Team Collaboration</h4>
                    <p className="text-gray-400 text-sm">Share and sync lint configurations across your entire development team</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-[#00d9ff]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-[#00d9ff]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Version Control</h4>
                    <p className="text-gray-400 text-sm">Track changes to your lint rules over time with built-in versioning</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
